<!-- 固定于右上角的活动规则按钮，需要放在 PinnedBtnContainer 中 -->
<template>
  <div @click="handleClick">
    <PinnedBtn :text="text" :buttonImage="buttonImage" />
  </div>
</template>

<script>
import PinnedBtn from './PinnedBtn';
export default {
  props: {
    buttonImage: String
  },
  components: { PinnedBtn },
  mounted() {
    this.$emit('reportEvent', {
      event: 'component_expo',
      module_name: this.$t ? this.$t('track.base_comp_rule') : '活动规则'
    });
  },
  computed: {
    text: function() {
      if (this.buttonImage) {
        return '';
      }
      return this.$t ? this.$t('base_comp_rule') : '活动规则';
    }
  },
  methods: {
    handleClick() {
      this.$emit('reportEvent', {
        event: 'component_button_click',
        module_name: this.$t ? this.$t('track.base_comp_rule') : '活动规则'
      });
      this.$router.push('/rule');
    }
  }
};
</script>
